export default __webpack_public_path__ + "static/media/benzinga-logo-white.c6498a94.svg";